import { Component } from '@angular/core';

@Component({
  selector: 'app-large-fleet',
  templateUrl: './large-fleet.component.html',
  styleUrl: './large-fleet.component.css'
})
export class LargeFleetComponent {

}
